import React, { useState } from 'react'
import styles from './MediaStats.module.scss'
import { EyeIcon, StarIcon, HeartIcon } from '../../../../../components/CustomIcons'

const MediaStats = ({ 
  media, 
  onRate, 
  userRating = null,
  stats = {},
  onLike = null,
  isLiked = false,
  isLikeLoading = false
}) => {
  const [hoveredRating, setHoveredRating] = useState(null)
  const [isRating, setIsRating] = useState(false)

  const handleRateClick = async (rating) => {
    if (isRating) return
    
    setIsRating(true)
    try {
      await onRate(rating)
      setHoveredRating(null)
    } catch (error) {
      console.error('Error rating media:', error)
    } finally {
      setIsRating(false)
    }
  }

  const displayRating = hoveredRating !== null ? hoveredRating : userRating

  return (
    <div className={styles.mediaStats}>
      <div className={styles.statsContainer}>
        {/* Просмотры */}
        <div className={styles.statItem}>
          <div className={styles.statIcon}>
            <EyeIcon />
          </div>
          <div className={styles.statContent}>
            <div className={styles.statLabel}>Просмотры</div>
            <div className={styles.statValue}>
              {media?.views_count?.toLocaleString('ru-RU') || 0}
            </div>
          </div>
        </div>

        {/* Средний рейтинг */}
        <div className={styles.statItem}>
          <div className={styles.statIcon}>
            <StarIcon />
          </div>
          <div className={styles.statContent}>
            <div className={styles.statLabel}>Средний рейтинг</div>
            <div className={styles.statValue}>
              {media?.rating_avg 
                ? `${parseFloat(media.rating_avg).toFixed(1)}/5` 
                : 'Нет оценок'}
            </div>
          </div>
        </div>

        {/* Ваша оценка — inline next to average rating */}
        <div className={`${styles.statItem} ${styles.ratingStatItem}`}>
          <div className={styles.statIcon}>
            <StarIcon />
          </div>
          <div className={styles.statContent}>
            <div className={styles.statLabel}>Ваша оценка</div>
            <div className={styles.ratingStars}>
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  className={`${styles.star} ${
                    (displayRating !== null && star <= displayRating) ? styles.filled : ''
                  } ${
                    (userRating !== null && star <= userRating) ? styles.active : ''
                  }`}
                  onClick={() => handleRateClick(star)}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(null)}
                  disabled={isRating}
                  title={`Оценить ${star} звезд${star === 1 ? 'е' : ''}`}
                >
                  ★
                </button>
              ))}
            </div>
            {userRating && (
              <div className={styles.ratingFeedback}>
                <strong>{userRating}/5</strong>
              </div>
            )}
          </div>
        </div>

        {/* Лайки — clickable when onLike provided */}
        {stats.likes_count !== undefined && (
          <div
            className={`${styles.statItem} ${onLike ? styles.likeStatItem : ''} ${isLiked ? styles.likedStat : ''}`}
            onClick={onLike || undefined}
            role={onLike ? 'button' : undefined}
            tabIndex={onLike ? 0 : undefined}
            onKeyDown={onLike ? (e) => { if (e.key === 'Enter' || e.key === ' ') onLike() } : undefined}
          >
            <div className={styles.statIcon}>
              <HeartIcon />
            </div>
            <div className={styles.statContent}>
              <div className={styles.statLabel}>{isLiked ? '❤️ Лайкнуто' : '🤍 Лайки'}</div>
              <div className={styles.statValue}>
                {isLikeLoading ? '...' : (stats.likes_count?.toLocaleString('ru-RU') || 0)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default MediaStats
